import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicy"] */ "/vercel/path0/modules/privacy-policy/PrivacyPolicy.tsx");
